import React from 'react';
import { motion } from 'framer-motion';
import styles from './Gallery.module.css';

const Gallery = () => {
  // Array of images including your local "working images" and relevant NGO photos
  const galleryImages = [
    { id: 1, url: "/images/working images/img11.jpg", title: "Food Distribution" },
    { id: 2, url: "/images/working images/img22.jpg", title: "Community Service" },
    { id: 3, url: "/images/working images/img30.webp", title: "Helping Hands" },
    { id: 4, url: "/images/working images/img33.jpg", title: "ZFoundation Team" },
    { id: 5, url: "/images/working images/img99.jpg", title: "Support Program" },
    { id: 6, url: "/images/working images/img44.webp", title: "Event Management" },
    { id: 7, url: "/images/working images/img66.jpg", title: "Education Drive" },
    { id: 8, url: "/images/working images/img55.jpg", title: "Volunteer Group" },
    { id: 9, url: "/images/working images/img20.webp", title: "Aid Distribution" },
    { id: 10, url: "/images/working images/img10.jpg", title: "Humanitarian Care" },
    { id: 11, url: "/images/working images/img77.jpg", title: "Mission Day" },
    { id: 12, url: "/images/working images/img88.jpg", title: "No Food" },
  ];

  return (
    <div className={styles.galleryPage}>
      {/* Header Banner */}
      <div className={styles.heroBanner}>
        <motion.h1
          initial={{ opacity: 0, scale: 0.8, letterSpacing: "15px" }}
          animate={{ opacity: 1, scale: 1, letterSpacing: "4px" }}
          transition={{ duration: 1.8, ease: "easeOut" }}
          className={styles.heroTitle}
        >
          GALLERY
          <p className={styles.heroSubtitle}>Capturing moments of change and compassion at ZFoundation</p>
        </motion.h1>
      </div>

      <div className={styles.container}>
        <div className={styles.masonryGrid}>
          {galleryImages.map((image) => (
            <div key={image.id} className={styles.galleryItem}>
              <div className={styles.imageWrapper}>
                <img src={image.url} alt={image.title} className={styles.image} />
                {/* Hover Overlay */}
                <div className={styles.overlay}>
                  <span className={styles.imageTitle}>{image.title}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;